import ICheckbox from "../../interfaces/checkbox";
import { Label } from "../atoms/label";
import * as React from "react";

const Checkbox = ({
  text,
  htmlFor,
  classNameLabel,
  classCheckbox,
  checked,
  onChange,
}: ICheckbox) => {
  return (
    <div className={classCheckbox}>
      <input
        className="form-check-input"
        type="checkbox"
        value=""
        id={htmlFor}
        checked={checked}
        onChange={onChange}
      />
      <Label text={text} htmlFor={htmlFor} className={classNameLabel} />
    </div>
  );
};

export default Checkbox;
